import classNames from 'classnames';
import React from 'react';

import withFormValidationProps from 'sharedreact/components/withFormValidationProps';

type Props = {
  id: string,
  className?: string,
  disabled?: boolean,
  type?: string,
  icon?: string,
  badgeValue?: React.ReactNode,
  children?: React.ReactNode,
  collapsable?: boolean,
  onlyShowIconWhenCollapsed?: boolean,
  active?: boolean,
  autoFocus?: boolean,
  title?: string,

  onClick?: React.MouseEventHandler<HTMLButtonElement>,
  // onMouseDown should only be used if you have a component that wants to
  // handle AEButon clicks and onBlur and wants different behaviour for those
  // actions
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>,
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>
};

type DefaultProps = Required<Pick<Props, 'type'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class Button extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    type: 'btn-default'
  };

  override render (): React.ReactNode {
    const { id,
      className,
      disabled,
      type,
      icon,
      badgeValue,
      children,
      collapsable,
      onlyShowIconWhenCollapsed,
      active,
      autoFocus,
      title,
      onClick,
      onMouseDown,
      onMouseEnter
    } = (this.props as PropsWithDefaults);

    const buttonClassName = classNames('esko_btn', type.split(' ').map(className => 'esko_' + className).join(' '), className, {
      active: active
    });

    const buttonDisabled = (onClick == null && onMouseDown == null) ||
      disabled;

    if (icon != null) {
      if (collapsable) {
        if (onlyShowIconWhenCollapsed) {
          return (
            <button id={id}
              type='button'
              className={buttonClassName}
              onClick={onClick}
              onMouseDown={onMouseDown}
              onMouseEnter={onMouseEnter}
              disabled={buttonDisabled}
              autoFocus={autoFocus}
              title={buttonDisabled ? undefined : title}
            >
              <div className='esko_visible-lg-inline esko_visible-md-inline'>
                {children}
              </div>
              <div className='esko_visible-xs-inline esko_visible-sm-inline'>
                <span className={icon}>
                  {badgeValue}
                </span>
              </div>
            </button>
          );
        } else {
          return (
            <button id={id}
              type='button'
              className={buttonClassName}
              onClick={onClick}
              onMouseDown={onMouseDown}
              onMouseEnter={onMouseEnter}
              disabled={buttonDisabled}
              autoFocus={autoFocus}
              title={buttonDisabled ? undefined : title}
            >
              <div className='esko_visible-lg-inline esko_visible-md-inline'>
                <span className={icon} style={React.Children.count(children) ? {marginRight: '5px'} : {}}>{badgeValue}</span>{children}
              </div>
              <div className='esko_visible-xs-inline esko_visible-sm-inline'>
                <span className={icon}>
                  {badgeValue}
                </span>
              </div>
            </button>
          );
        }
      } else {
        return (
          <button id={id}
            type='button'
            className={buttonClassName}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            disabled={buttonDisabled}
            autoFocus={autoFocus}
            title={buttonDisabled ? undefined : title}
          >
            <span className={icon} style={React.Children.count(children) ? {marginRight: '5px'} : {}}>{badgeValue}</span>{children}
          </button>
        );
      }
    } else {
      return (
        <button id={id}
          type='button'
          className={buttonClassName}
          onClick={onClick}
          onMouseDown={onMouseDown}
          onMouseEnter={onMouseEnter}
          disabled={buttonDisabled}
          autoFocus={autoFocus}
          title={buttonDisabled ? undefined : title}
        >
          {children}
        </button>
      );
    }
  }
}

export default withFormValidationProps(Button);
